import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet],
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent {}
